<template>
  <div>
    <b-form-checkbox
      v-model="selected"
      value="C"
      class="custom-control-success"
    >
      فعال سازی به عنوان افراد موفق
    </b-form-checkbox>
    <div
      v-if="selected"
      class="mt-2"
    >
      <b-card
        title="مصاحبه"
        border-variant="dark"
      >
        <b-card-body>
          <b-tabs
            vertical
            start
            nav-class="nav-left"
            nav-wrapper-class="nav-vertical"
            pills
          >
            <b-tab
              active
              title="فارسی"
            >
              <b-form-textarea
                id="textarea-default"
                placeholder="Textarea"
                rows="4"
                max-rows="50"
              />
            </b-tab>
            <b-tab title="انگلیسی">
              <b-form-textarea
                id="textarea-default"
                placeholder="Textarea"
                rows="4"
                max-rows="50"
              />
            </b-tab>
            <b-tab title="عربی">
              <b-form-textarea
                id="textarea-default"
                placeholder="Textarea"
                rows="4"
                max-rows="50"
              />
            </b-tab>
          </b-tabs>
        </b-card-body>
        <div
          v-if="selected"
          class="mt-2"
        >
          <b-card-title>
            مستندات
          </b-card-title>
          <b-card-body class="d-flex">
            <label
              class="align-self-end"
              for="BeforeImage"
            >

              <div
                class="d-flex flex-wrap"
              >
                <b-card
                  class="icon-card cursor-pointer text-center mb-2 mx-50"
                  no-body
                  border-variant="info"
                >
                  <b-card-body>
                    <div>
                      <div
                        v-if="BeforeImagePreview"
                      >
                        <b-img
                          :src="BeforeImagePreview"
                          width="90"
                          height="100"
                        />
                      </div>
                      <div
                        v-else
                        class="icon-wrapper"
                      >
                        <feather-icon
                          icon="UploadCloudIcon"
                          size="24"
                          class="text-info"
                        />
                      </div>
                      <b-card-text class="icon-name text-truncate mb-0 mt-1">
                        <span class="text-info">عکس قبل</span>
                      </b-card-text>
                    </div>
                  </b-card-body>
                </b-card>
              </div>
              <input
                id="BeforeImage"
                ref="inputFile"
                type="file"
                style="display:none"
                @input="InitBeforeImage"
              >
            </label>
            <label
              class="align-self-end"
              for="afterImage"
            >

              <div
                class="d-flex flex-wrap"
              >
                <b-card
                  class="icon-card cursor-pointer text-center mb-2 mx-50"
                  no-body
                  border-variant="info"
                >
                  <b-card-body>
                    <div>
                      <div
                        v-if="afterImagePreview"
                      >
                        <b-img
                          :src="afterImagePreview"
                          width="90"
                          height="100"
                        />
                      </div>
                      <div
                        v-else
                        class="icon-wrapper"
                      >
                        <feather-icon
                          icon="UploadCloudIcon"
                          size="24"
                          class="text-info"
                        />
                      </div>
                      <b-card-text class="icon-name text-truncate mb-0 mt-1">
                        <span class="text-info">عکس بعد</span>
                      </b-card-text>
                    </div>
                  </b-card-body>
                </b-card>
              </div>
              <input
                id="afterImage"
                ref="inputFile"
                type="file"
                style="display:none"
                @input="InitAfterImage"
              >
            </label>
            <label
              class="align-self-end"
              for="interviewVideo"
            >

              <div
                class="d-flex flex-wrap"
              >
                <b-card
                  class="icon-card cursor-pointer text-center mb-2 mx-50"
                  no-body
                  border-variant="info"
                >
                  <b-card-body>
                    <div>
                      <div
                        v-if="interviewVideo"
                      >
                        <video
                          :src="interviewVideoPreview"
                          width="90"
                          height="100"
                          controls
                        />
                      </div>
                      <div
                        v-else
                        class="icon-wrapper"
                      >
                        <feather-icon
                          icon="UploadCloudIcon"
                          size="24"
                          class="text-info"
                        />
                      </div>
                      <b-card-text class="icon-name text-truncate mb-0 mt-1">
                        <span class="text-info">فیلم مصاحبه</span>
                      </b-card-text>
                    </div>
                  </b-card-body>
                </b-card>
              </div>
              <input
                id="interviewVideo"
                type="file"
                style="display:none"
                @input="InitInterviewVideo"
              >
            </label>
          </b-card-body>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="save"
          >
            ذخیره
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>

export default {
  name: 'UserSuccess',
  components: {
  },
  data() {
    return {
      selected: true,
      beforeImage: null,
      BeforeImagePreview: null,
      afterImage: null,
      afterImagePreview: null,
      interviewVideo: null,
      interviewVideoPreview: null,
    }
  },
  methods: {
    save() {},
    InitAfterImage(e) {
      const file = this.getFile(e)
      if (!file) return false
      this.afterImage = file
      this.afterImagePreview = URL.createObjectURL(file)
      return true
    },
    InitBeforeImage(e) {
      const file = this.getFile(e)
      this.beforeImage = file
      this.BeforeImagePreview = URL.createObjectURL(file)
      return true
    },
    InitInterviewVideo(e) {
      const file = this.getFile(e)
      this.interviewVideo = file
      this.interviewVideoPreview = URL.createObjectURL(file)
      return true
    },
    getFile(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return false
      }
      return (files[0])
    },
  },
}
</script>

<style scoped>

</style>
